import { Component, OnInit ,EventEmitter ,Input ,Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IgxListLineTitleDirective } from 'igniteui-angular';
import { CategoryItem ,Category, categories} from 'src/app/models/category';
import { MyOrder } from 'src/app/models/order';
import { AppProxy } from 'src/app/services/app-proxy';
import { BussinssService } from 'src/app/services/bussinss-service';
import { DataService } from 'src/app/services/data.service';
import { OrdersService } from 'src/app/services/order-service';
import { PopupOrderComponent } from '../popup-order/popup-order.component';
import { OpenningHours} from 'src/app/models/restaurant'

@Component({
  selector: 'app-category-item',
  templateUrl: './category-item.component.html',
  styleUrls: ['./category-item.component.scss']
})
export class CategoryItemComponent implements OnInit {
  stars:number[]=[1,2,3,4,5];
@Input() categoryItem:categories;
  @Input() listId:number;
  @Output()
  change: EventEmitter<number> = new EventEmitter<number>();
  categoryType:number=1;
  clickFevorite=false;
  fevorit='assets/images/Restorant_Page_Fevorit_Button.png';
  fevoritActive='assets/images/Restorant_Page_Fevorit_Button_On.png';
  order:MyOrder;
  openningHours:OpenningHours[]=[];
  localId;
  Rate= new Array<number>(3);
  isClick=false;
  dayTime="";

  constructor(private router: Router,private dataService:DataService,private matDialog:MatDialog, private proxy: AppProxy,private bussinssService: BussinssService ,private orderService:OrdersService) {  }

  onClickCategory()
  {
    if(localStorage.SMS=="")
   this.proxy.showError("חובה להכניס קוד","");
    if(localStorage.ACCESS_TOKEN  == "null" || localStorage.SMS_CODE=="")
    this.proxy.showError("אינך מחובר נא להתחבר","");
    else
    {
      this.dataService.search.next("");
      this.orderService.restaurant=null;
      localStorage.PRICE=0;
      this.isClick=true;

      localStorage.TEXT=this.categoryItem.Category;
      this.dataService.categoryId.next(this.categoryItem.ID);
      this.dataService.listId.next(this.listId);
    let url: string = "/restaurantCategory/" + this.categoryItem.CategoryEn;
      this.router.navigateByUrl(url);
    }
  }

  ngOnInit(): void {

  }




}
